import { chain } from 'icepick';
import type { Action, StoreActionApi } from 'react-sweet-state';
import { DATE_ERROR_TYPES } from '../../../../common/constants/errors';
import type { State } from '../../../../common/types';

export type RemoveDateValidationErrors = () => Action<State, void, void>;

export const removeDateValidationErrors =
	() =>
	({ setState, getState }: StoreActionApi<State>) => {
		const state = getState();

		if (!state.mappingState || !state.mappingState.validationError) {
			return;
		}

		const { columnErrors } = state.mappingState.validationError;

		Object.entries(columnErrors).forEach(([columnName, errorType]) => {
			if (DATE_ERROR_TYPES.has(errorType)) {
				delete columnErrors[columnName];
			}
		});

		const newState = chain(state)
			.setIn(['mappingState', 'validationError', 'columnErrors'], columnErrors)
			.value();

		setState(newState);
	};
